/**
 * Mappers for converting Shopify cart data to our unified models
 */

/**
 * Map create cart response to flatten nested structures
 * Handles both nodes and edges patterns for backward compatibility
 */
export function mapCreateCartToResponse(cart: any): any {
  if (!cart) return cart;

  return {
    ...cart,
    // Flatten lines - convert from nodes or edges/node to direct array
    lines:
      cart.lines?.nodes ||
      cart.lines?.edges?.map((edge: any) => edge.node) ||
      [],
  };
}

/**
 * Map get cart response to flatten nested structures
 * Handles both nodes and edges patterns for backward compatibility
 */
export function mapGetCartToResponse(cart: any): any {
  if (!cart) return cart;

  return {
    ...cart,
    // Flatten lines - convert from nodes or edges/node to direct array
    lines:
      cart.lines?.nodes ||
      cart.lines?.edges?.map((edge: any) => edge.node) ||
      [],
  };
}

/**
 * Map update cart response to flatten nested structures
 * Handles both nodes and edges patterns for backward compatibility
 */
export function mapUpdateCartToResponse(cart: any): any {
  if (!cart) return cart;

  return {
    ...cart,
    // Flatten lines - convert from nodes or edges/node to direct array
    lines:
      cart.lines?.nodes ||
      cart.lines?.edges?.map((edge: any) => edge.node) ||
      [],
  };
}

/**
 * Map add to cart response to flatten nested structures
 * Handles both nodes and edges patterns for backward compatibility
 */
export function mapAddToCartToResponse(cart: any): any {
  if (!cart) return cart;

  return {
    ...cart,
    // Flatten lines - convert from nodes or edges/node to direct array
    lines:
      cart.lines?.nodes ||
      cart.lines?.edges?.map((edge: any) => edge.node) ||
      [],
  };
}

/**
 * Map remove from cart response to flatten nested structures
 * Handles both nodes and edges patterns for backward compatibility
 */
export function mapRemoveFromCartToResponse(cart: any): any {
  if (!cart) return cart;

  return {
    ...cart,
    // Flatten lines - convert from nodes or edges/node to direct array
    lines:
      cart.lines?.nodes ||
      cart.lines?.edges?.map((edge: any) => edge.node) ||
      [],
  };
}
